import script from "./NameUpdate.vue?vue&type=script&setup=true&lang=ts"
export * from "./NameUpdate.vue?vue&type=script&setup=true&lang=ts"

import "./NameUpdate.vue?vue&type=style&index=0&id=8fdc6cf4&lang=scss"

const __exports__ = script;

export default __exports__